<div class="response-container" [class.response-container--streaming]="showStreamingCursor">
  <!-- Markdown Answer using granular component -->
  <app-shared-markdown-renderer
    *ngIf="answer"
    [content]="answer"
    [agentId]="agentId"
    [fusionAppUiUrl]="fusionAppUiUrl"
    [enableInsLinkNavigation]="enableInsLinkNavigation"
    [isStreaming]="isStreaming"
    [wrapperClass]="'markdown-answer'"
    [enableScrolling]="true"
    [enableLatexScrollbars]="true"
    [enableTableClassDetection]="true"
    [enableLinkProcessing]="true"
    [enableListFormatting]="true"
    [enableRichTables]="enableRichTables"
    [enableS3FileAttachments]="enableS3FileAttachments"
    [showFileAttachmentActions]="showFileAttachmentActions"
    [filePathsInOrder]="filePathsInOrder"
    [enableTableSearch]="enableTableSearch"
    [enableTableColumnFilter]="enableTableColumnFilter"
    [enableTableDownload]="enableTableDownload"
    [isTablePaginationEnabled]="isTablePaginationEnabled"
    [isStreaming]="isStreaming"
    (tableDownloaded)="tableDownloaded.emit($event)"
    (tableDownloadFailed)="tableDownloadFailed.emit()"
    (filePreviewRequested)="filePreviewRequested.emit($event)"
    (filePreviewFailed)="filePreviewFailed.emit($event)"
    (fileDownloadCompleted)="fileDownloadCompleted.emit($event)"
    (fileDownloadFailed)="fileDownloadFailed.emit($event)">
  </app-shared-markdown-renderer>
  
  
  <!-- Image Visualization using granular component -->
  <app-shared-image-visualization
    *ngIf="imageVisualization"
    [imageSource]="imageVisualization"
    [wrapperClass]="'markdown-answer'"
    [enableScrolling]="true">
  </app-shared-image-visualization>
  
  <!-- Chart Visualization -->
  <div *ngIf="hasVisualization()" class="visualization-section">
    <div class="charts-container" 
         [ngClass]="{
           'single-chart': visualizationData.length === 1,
           'two-charts': visualizationData.length === 2,
           'multiple-charts': visualizationData.length > 2
         }">
      <div class="chart-item" 
           *ngFor="let chart of visualizationData; let i = index"
           [ngClass]="{
             'chart-single': visualizationData.length === 1,
             'chart-two': visualizationData.length === 2,
             'chart-multiple': visualizationData.length > 2
           }">
        <app-chart 
          [chartData]="chart" 
          [isSmall]="visualizationData.length > 1">
        </app-chart>
      </div>
    </div>
  </div>
  
  
  <!-- Error Display -->
  <div class="error-display" *ngIf="errorMessage">
    <div class="error-content">
      <strong>Error:</strong> {{ errorMessage }}
    </div>
  </div>

  <!-- RIA: single blinking dot at end of streamed content (after text has started) -->
  <app-agent-streaming-cursor *ngIf="showStreamingCursor"></app-agent-streaming-cursor>
</div>

